import { lazyPage } from "@core/app/lazyPage";
import type { WebModule } from "@modules/registry";

const AddressStepPage = lazyPage(() => import("./pages/AddressStepPage"), "AddressStepPage");
const ReviewStepPage = lazyPage(() => import("./pages/ReviewStepPage"), "ReviewStepPage");

export const checkoutModule: WebModule = {
  id: "checkout",
  nav: null,
  routes: [
    { path: "/checkout", element: <AddressStepPage /> },
    { path: "/checkout/review", element: <ReviewStepPage /> },
  ],
  publicRoutes: [],
};
